// The "due …" label on a Planner list task card (Jade, 2026-10-09).
//
// Tasks have always stored dueDate = startDate when no separate due date was
// picked (see buildItemPayload), so a dueDate alone doesn't mean the person
// set one. Only a due date that differs from the start date is a real one —
// that's the only time the card shows it. Lower-case "due" (Jade), and
// "due today" rather than today's date.
//
// A due time (2026-10-10) is added after the date ("due Oct 12, 11:59 PM"), and
// makes the label show even when the due date is the start date — "start
// today, due tonight 11:59 PM" is a real due date.
// Did the person actually pick this task's due date? A dueDate that differs
// from the start is always real. One ON the start day is real too when the
// task carries a dueTime field at all — even "" (no time): since due times
// arrived, every save with a due date picked writes the field and a save
// without one leaves it out (buildItemPayload), so "due today" with no time
// isn't mistaken for the stored default (Jade, 2026-10-10).
export function hasPickedDueDate(task) {
  if (!task || !task.dueDate) return false;
  return task.dueDate !== (task.startDate || task.dueDate) || typeof task.dueTime === "string";
}

export function taskDueLabel(task, today) {
  if (!hasPickedDueDate(task)) return null;
  const due = task.dueDate;
  const dueTime = task.dueTime || "";
  let label;
  if (due === today) label = "due today";
  else {
    const d = new Date(`${due}T00:00:00`);
    const opts = { month: "short", day: "numeric" };
    if (today && due.slice(0, 4) !== today.slice(0, 4)) opts.year = "numeric";
    label = `due ${d.toLocaleDateString("en-US", opts)}`;
  }
  if (!dueTime) return label;
  const t = new Date(`2000-01-01T${dueTime}`).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return `${label}, ${t}`;
}
